<div class="table-wrapper" #tableWrapper>
  <table class="products-list" *ngIf="_activeOrder">
    <thead>
    <tr class="font-5">
      <th class="product-image">Product</th>
      <th class="product-details">Details</th>
      <ng-container *ngIf="isEmptyAddressList; else addressHeader">
        <th class="delivery">
            <ng-container *ngIf="canEditOrder">
                Add Location
                <button class="btn btn-icon" (click)="addLocation()"><i class="fal fa-edit"></i></button>
            </ng-container>
            <ng-container *ngIf="!canEditOrder">
                Location
            </ng-container>
        </th>
      </ng-container>
      <th class="product-subtotal">Product Subtotal</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let product of _products"  app-product-list-item [product]="product"  [orderType]="orderType">
    </tr>
    </tbody>
    <tfoot>
      <tr class="tfoot">
        <th class="product-image vertical-middle" colspan="2">
          <div class="text-right">
            <span>LOCATION SUBTOTAL&nbsp;</span>
          </div>

        </th>
        <ng-container *ngIf="isEmptyAddressList; else addressFooter">
          <th class="delivery">
            &nbsp;
          </th>
        </ng-container>

        <th class="product-subtotal ">
          <div class="d-flex flex-column align-items-center">
            <span class="font-weight-normal  uppercase">Orders Total</span>
            <div>
              <app-currency-price [price]="_activeOrder.totalCost" [currency]="_activeOrder.currency"></app-currency-price>
            </div>
          </div>
        </th>
      </tr>
    </tfoot>
  </table>
</div>


<ng-template #addressHeader>

    <th *ngFor="let address of addressList" class="delivery">
        <div class="d-flex align-items-center gap-10"><span class="address-field">{{ address.label }}</span>&nbsp;
            <button class="btn btn-icon" (mousedown)="editLocation()"><i class="fal fa-edit"></i></button>
        </div>
        <span  class="address-field">{{ address.street_1 }}</span>
    </th>
</ng-template>


<ng-template #addressFooter>

  <th *ngFor="let address of addressList" class="delivery">
    <div class="text-center">
      <span class="font-weight-bold price"><app-currency-price [price]="calcSubtotalsForAddress(address)" [currency]="_activeOrder.currency"></app-currency-price></span>
    </div>
  </th>
</ng-template>
